import { Button, Modal, ModalProps } from 'antd';
import { MacScrollbar } from 'mac-scrollbar';
import React from 'react';
import ActionButton from '@/components/MsgModal/ActionButton';

interface FormModalProps extends ModalProps {
  close?: () => void;
  showFootBtn?: boolean;
  width?: string | number;
  padding?: string | number;
  contentPadding?: string | number;
  maxHeight?: string | number;
  footerStyle?: React.CSSProperties;
  needCancelBtn?: boolean;
  hideMacScroll?: boolean;
}

const FormModal: React.FC<FormModalProps> = (p) => {
  const {
    title,
    okText,
    showFootBtn = true,
    onOk,
    okButtonProps,
    close,
    cancelText,
    children,
    width = '660px',
    maxHeight = '596px',
    padding = '40px 55px 70px 105px',
    contentPadding = '36px 50px 0 0',
    needCancelBtn = true,
    footerStyle,
    hideMacScroll,
  } = p;
  const scrollContent = hideMacScroll ? (
    <div style={{ padding: contentPadding }}>{children}</div>
  ) : (
    <MacScrollbar
      className="overflow-y-auto"
      style={{ padding: contentPadding }}
    >
      {children}
    </MacScrollbar>
  );
  return (
    <Modal
      {...p}
      destroyOnClose
      width={width}
      bodyStyle={{ padding }}
      centered
      footer={null}
      title={null}
    >
      <div className="flex flex-col" style={{ maxHeight }}>
        <div className="flex text-18 text-secondary font-medium justify-center">
          {title}
        </div>
        {scrollContent}
        {showFootBtn && (
          <div
            className="flex flex-shrink-0 justify-center pt-[30px] space-x-3"
            style={footerStyle}
          >
            <ActionButton
              actionFn={onOk}
              close={close}
              buttonProps={{
                className: 'w-[190px]',
                size: 'large',
                type: 'primary',
                danger: true,
                shape: 'round',
                ...okButtonProps,
              }}
            >
              {okText || '保存'}
            </ActionButton>
            {needCancelBtn && (
              <Button
                className="w-[190px]"
                size="large"
                shape="round"
                onClick={p.onCancel}
              >
                {cancelText || '取消'}
              </Button>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default FormModal;
